<template>
  <svg
    ref="svg"
    class="morphing-infinity"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    role="status"
    aria-label="Loading"
  >
    <path ref="path" :d="infinityPath" />
  </svg>
</template>

<script>
import { animate } from 'motion';

const circleA = 'M 12 8 C 14.21 8 16 9.79 16 12 C 16 14.21 14.21 16 12 16 C 9.79 16 8 14.21 8 12 C 8 9.79 9.79 8 12 8 Z';
const infinity = 'M 12 12 C 14 8.5 19 8.5 19 12 C 19 15.5 14 15.5 12 12 C 10 8.5 5 8.5 5 12 C 5 15.5 10 15.5 12 12 Z';
const circleB = 'M 12 16 C 14.21 16 16 14.21 16 12 C 16 9.79 14.21 8 12 8 C 9.79 8 8 9.79 8 12 C 8 14.21 9.79 16 12 16 Z';

export default {
  name: 'MorphingInfinity',
  data() {
    return { controls: null, infinityPath: infinity };
  },
  mounted() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.controls = animate(
      this.$refs.path,
      { d: [circleA, infinity, circleB, infinity, circleA] },
      { duration: 5, ease: 'ease-in-out', repeat: Infinity, times: [0, 0.25, 0.5, 0.75, 1] },
    );
  },
  beforeUnmount() {
    if (this.controls && this.controls.stop) this.controls.stop();
  },
};
</script>

<style scoped>
.morphing-infinity {
  display: block;
  width: 1.8rem;
  height: 1.8rem;
}
</style>
